import axios from 'axios';


const url = '/api/configuration/project';

export const getList = ({ q, groupId, userId } = {}) => axios.get(url, { params: { q, groupId, userId } })
  .then(response => response.data);

export const get = ({ id }) => axios.get(`${url}/${id}`)
  .then(response => response.data);

export const getTemplate = ({ companyId }) => axios.get(`${url}/template`, { params: { companyId } })
  .then(response => response.data);

export const getItemsConfiguration = ({ projectId }) => axios.get(`${url}/items-configuration`, { params: { projectId } })
  .then(response => response.data);

export const updateItemsConfiguration = ({
  projectId,
  item,
 }) => axios.post(`${url}/items-configuration`, { projectId, item })
    .then(response => response.data);

export const getStatuses = ({ projectId }) => axios.get(`${url}/statuses`, { params: { projectId } })
  .then(response => response.data);

export const upsertStatus = ({
    projectId,
  status,
   }) => axios.post(`${url}/statuses`, { projectId, status })
    .then(response => response.data);

export const getTags = ({ projectId }) => axios.get(`${url}/tags`, { params: { projectId } })
  .then(response => response.data);

export const upsertTags = ({
    projectId,
  tags,
   }) => axios.post(`${url}/tags`, { projectId, tags })
    .then(response => response.data);

export const getBoards = ({ projectId }) => axios.get(`${url}/boards`, { params: { projectId } })
  .then(response => response.data);

export const upsertBoard = ({
    projectId,
  board,
   }) => axios.post(`${url}/boards`, { projectId, board })
    .then(response => response.data);

export const getCategories = ({ projectId }) => axios.get(`${url}/categories`, { params: { projectId } })
  .then(response => response.data);

export const upsertCategory = ({
    projectId,
  category,
   }) => axios.post(`${url}/categories`, { projectId, category })
    .then(response => response.data);

export const upsert = ({
  projectId,
  name,
  description,
  startDate,
  isActive,
  companyId,
  workingTimings,
  workingDayInherit,
  estimationUnit,
  costOfEstimationUnit,
  projectType
}) => axios.post(url,
    {
      projectId,
      name,
      description,
      startDate,
      isActive,
      companyId,
      workingTimings,
      workingDayInherit,
      estimationUnit,
      costOfEstimationUnit,
      projectType
    })
    .then(response => response.data);

export const getTemplates = ({ projectId }) => axios.get(`${url}/templates`, { params: { projectId }})
  .then(response => response.data);

export const upsertTemplate = ({
                                 projectId,
                                 itemTemplate,
                               }) => axios.post(`${url}/templates`, { projectId, itemTemplate })
  .then(response => response.data);

export const checkIsProjectNameUnique = ({ name, groupId, projectId }) => axios.get(`${url}/is-exists`,
  { params: { projectName: name, groupId, projectId } })
  .then(response => response.data);


// WEBPACK FOOTER //
// ../utils/api/configuration/project.js